import axios from "axios";
const api_url = process.env.REACT_APP_STEM_API_BASE_URL + "/api";

const fileUploadHeaderConfig = {
    headers: {
        'content-type': 'multipart/form-data',
    }
};

export const pwUrl = () => {
    const api_url_pwupload = api_url + "/Importer/ImportEmployees"
    return api_url_pwupload
}

export const KraUrl = () => {
    const api_url_kraupload = api_url + "/Importer/ImportEmployeeKRA"
    return api_url_kraupload
}

export const AttrationUrl=()=>{
    const api_url_attrationupload=api_url+"/Importer/ImportAttration"
    return api_url_attrationupload;
}
export const AttendanceUrl=()=>{
    const api_url_attendanceupload=api_url+"/Importer/ImportAttendance"
    return api_url_attendanceupload;
}
export const UploadEmployeeEntries = (formData: any) => {
    let url = api_url + "/Importer/ImportEmployees";
    return axios.post(url, formData, fileUploadHeaderConfig);
} 

export const PktUrl=()=>{
    const api_url_pkt=api_url+"/Importer/ImportPKT";
    return api_url_pkt;
}

export const QualityUrl=()=>{
    const api_url_quality=api_url+"/Importer/ImportQuality";
    return api_url_quality;
}